import React from 'react';
import getClassNames from 'classnames';

import Element, { CommonProps } from '../../Element/Element';
import styles from '../Table.module.scss';

type TableRowProps = Omit<CommonProps<'tr'>, 'tagName'>;

const TableRow: React.FunctionComponent<TableRowProps> = ({
  className,
  children,
  ...props
}) => {
  const classNames = getClassNames(styles.table_row, className);

  return (
    <Element tagName="tr" className={classNames} {...props}>
      {children}
    </Element>
  );
};

export default TableRow;
